import { useRef as d, useEffect as f, useState as m, useLayoutEffect as L, useCallback as x } from "react";
import { c as u } from "./_commonjsHelpers-DaMA6jEr.js";
var M = typeof u == "object" && u && u.Object === Object && u, R = typeof self == "object" && self && self.Object === Object && self;
M || R || Function("return this")();
var E = typeof window < "u" ? L : f;
function I(e, t, r, s) {
  const o = d(t);
  E(() => {
    o.current = t;
  }, [t]), f(() => {
    const c = (r == null ? void 0 : r.current) ?? window;
    if (!(c && c.addEventListener))
      return;
    const i = (n) => {
      o.current(n);
    };
    return c.addEventListener(e, i, s), () => {
      c.removeEventListener(e, i, s);
    };
  }, [e, r, s]);
}
var j = typeof window > "u";
function k(e, {
  defaultValue: t = !1,
  initializeWithValue: r = !0
} = {}) {
  const s = (n) => j ? t : window.matchMedia(n).matches, [o, c] = m(() => r ? s(e) : t);
  function i() {
    c(s(e));
  }
  return E(() => {
    const n = window.matchMedia(e);
    return i(), n.addListener ? n.addListener(i) : n.addEventListener("change", i), () => {
      n.removeListener ? n.removeListener(i) : n.removeEventListener("change", i);
    };
  }, [e]), o;
}
function p() {
  const e = d(!1);
  return f(() => (e.current = !0, () => {
    e.current = !1;
  }), []), x(() => e.current, []);
}
var z = {
  width: void 0,
  height: void 0
};
function A(e) {
  const { ref: t, box: r = "content-box" } = e, [{ width: s, height: o }, c] = m(z), i = p(), n = d({ ...z }), a = d(void 0);
  return a.current = e.onResize, f(() => {
    if (!t.current || typeof window > "u" || !("ResizeObserver" in window))
      return;
    const l = new ResizeObserver(([v]) => {
      const b = r === "border-box" ? "borderBoxSize" : r === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", h = g(v, b, "inlineSize"), w = g(v, b, "blockSize");
      if (n.current.width !== h || n.current.height !== w) {
        const S = { width: h, height: w };
        n.current.width = h, n.current.height = w, a.current ? a.current(S) : i() && c(S);
      }
    });
    return l.observe(t.current, { box: r }), () => {
      l.disconnect();
    };
  }, [r, t, i]), { width: s, height: o };
}
function g(e, t, r) {
  return e[t] ? Array.isArray(e[t]) ? e[t][0][r] : (
    // @ts-ignore Support Firefox's non-standard behavior
    e[t][r]
  ) : t === "contentBoxSize" ? e.contentRect[r === "inlineSize" ? "width" : "height"] : void 0;
}
export {
  k as a,
  A as b,
  I as u
};
